import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

export type UseTrackerIntegrationsProps<T> = {
  filters?: {
    page?: number
    companyId?: string
  }
  mapper?: (data: any) => T,
}

export const useTrackerIntegrations = <T,>({
  filters: { page, companyId } = {},
  mapper = Mapper.default<T>(),
}: UseTrackerIntegrationsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['trackerIntegrations', page, companyId],
    queryFn: () => {
      return privateAxios.get(`/client/tracker_integrations`, {
        params: {
          page,
          'q[company_id_eq]': companyId
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
